import React from "react";
import { ContentSection, ButtonRenderProps } from "sprint-common-web";

import {
    ensureAudioFileRecordDetails,
    isFileRecordDetailsEditable
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { AudioFileRecordTechnicalView } from "../../../../../../common/file-record-details/technical/AudioFileRecordTechnicalView";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import {
    EditAudioTechnicalButtonAside,
    EditAudioTechnicalButtonAsideProps
} from "./edit/EditAudioTechnicalButtonAside";

export const AudioFileRecordTechnicalSection = (): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();
    ensureAudioFileRecordDetails(fileRecordDetails);

    const editAudioTechnicalInfoButtonAside: ButtonRenderProps<EditAudioTechnicalButtonAsideProps> = {
        fileRecordId: fileRecordDetails.id,
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditAudioTechnicalButtonAside
    };

    const buttons = [editAudioTechnicalInfoButtonAside];

    return (
        <ContentSection header="Technical" isLoading={isLoading} style={{ height: 300 }} buttons={buttons}>
            <AudioFileRecordTechnicalView fileRecordDetails={fileRecordDetails} />
        </ContentSection>
    );
};
